module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/companies-15b7916d1df42270ad69b416de5621fd.svg";